import { useMutation } from "@tanstack/react-query";
import { toast } from "@/lib/toast";
import api from "@/lib/axios";
import { useAuthStore } from "@/store/auth.store";

export function useMarkTutorialSeen() {
  const setUser = useAuthStore((state) => state.setUser);
  const user = useAuthStore((state) => state.user);

  return useMutation({
    mutationFn: async () => {
      const { data } = await api.patch<{ data: { onboarding_tour_seen_at: string } }>(
        "/v1/perfil/tutorial-visto",
      );
      return data.data.onboarding_tour_seen_at;
    },
    onSuccess: (onboardingTourSeenAt) => {
      if (user) setUser({ ...user, onboarding_tour_seen_at: onboardingTourSeenAt });
    },
    onError: () => {
      toast.error("Não foi possível salvar que o tutorial foi visto. Ele pode reaparecer no próximo login.");
    },
  });
}
